import axios from 'axios'

const instance = axios.create()

instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token && !config.headers.Authorization && config.url.indexOf('/api') === 0) {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }

    return config
  },
  error => {
    if (
      (error.response.status === 403 || error.response.status === 401) &&
      window.location.href.indexOf('/login') === -1
    ) {
      window.location.href = '/pages/login'
      return
    }

    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (
      (error.response.status === 403 || error.response.status === 401) &&
      window.location.href.indexOf('/login') === -1
    ) {
      window.location.href = '/pages/login'
      return
    }

    return Promise.reject(error)
  }
)

export default instance
